import ENV from "../lib/config";

export const getCompanyApiUrl = (path) =>
  `${ENV.get().REACT_APP_COMPANY_API_URL}${path}`;

export const getQuoteApiUrl = (path) =>
  `${ENV.get().REACT_APP_QUOTE_API_URL}${path}`;
